import { render, staticRenderFns } from "./coachVipApply.vue?vue&type=template&id=3aac2301&scoped=true&"
import script from "./coachVipApply.vue?vue&type=script&lang=js&"
export * from "./coachVipApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aac2301",
  null
  
)

export default component.exports